const allowedTenants = ["Snow1", "Snow2", "EverythingPets", "FluentStream", "FunctionalTest"];

export function isAllowedTenant() {
    const currentTenant = App.Configurations.get("tenant");
    return allowedTenants.includes(currentTenant);
}